export const webAccountChannel = 'web_account_channel';
